import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { VwoService } from '../../shared/services';
import { IPaymentSipConfig } from '../payment-sip/payment-sip.model';

@Component({
  selector: 'app-payment-sip-emandate',
  templateUrl: './payment-sip-emandate.component.html',
  styleUrls: ['./payment-sip-emandate.component.scss']
})
export class PaymentSipEmandateComponent implements OnInit {

  @Input() config: IPaymentSipConfig;
  @Output() dataEmit = new EventEmitter();

  constructor(
    public vwo: VwoService
  ) { }

  ngOnInit() {
  }

  submitOrder(data) {
    if (!this.config.selectEmandateBank) {
      data['auth_mode'] = 'DEBIT_CARD';
    }
    this.dataEmit.emit(data);
  }

}
